import { FC } from "react";
import { Toaster, toast } from "react-hot-toast";

interface Props {
  shareText: string;
}

export const ShareButton: FC<Props> = ({ shareText }) => {
  const pageLang = document.querySelector("body")?.dataset?.pageLang;

  const handleShare = () => {
    const toShare = `${
      window.location.href.split("#")[0]
    }#:~:text=${encodeURIComponent(shareText).replaceAll("-", "%2D")}`;

    navigator.clipboard.writeText(toShare);

    if (!pageLang) return;

    toast.success(pageLang === "nl" ? "Link gekopieerd" : "Lien copié");
  };

  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          success: {
            style: {
              fontSize: "1.2rem",
              color: "#801F86",
            },
          },
        }}
      />
      <button onClick={handleShare}>
        <svg
          width="22"
          height="24"
          viewBox="0 0 22 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5991 14.22L15.5991 14.37L14.5991 14.66L13.7791 15.12L13.0591 14.67L12.2591 14.25L11.3891 13.95L10.5991 13.49L9.85907 12.95L9.13907 12.45L9.30907 11.7L8.99907 10.81L9.89906 10.52L10.6591 10.03L11.2791 9.28997L12.2091 9.09997L13.0791 8.78997L13.7391 8.07997L14.5491 8.83997L15.6191 8.95997L16.6191 9.20997L17.6191 8.89997L18.6191 8.79997L19.4491 8.21997L20.1291 7.47997L20.5291 6.56997L20.9891 5.68997L21.1391 4.68997V3.68997L20.6091 2.80997L20.3091 1.80997L19.3091 1.39997L18.5191 0.849968L17.7091 0.10997L16.7091 0.0299683L15.7091 0.559971L14.7091 0.69997L13.7791 1.13997L12.9691 1.79997L12.6991 2.79997L12.1391 3.67997L12.0891 4.67997L12.3391 5.67997L11.3391 5.86997L10.7291 6.61997L9.92906 7.04997L9.09908 7.41997L8.37907 7.99997L7.43907 8.06997L6.58907 7.73997L5.58907 7.32997H4.58907L3.58907 7.41997H2.52907L1.74907 8.10997L1.11906 8.88997L0.449066 9.64997L0.379074 10.65L0.139069 11.68L0.0390625 12.68L0.379074 13.68L1.27907 14.3L1.86906 15.1L2.68907 15.68L3.68907 15.8L4.68907 16.08L5.68907 15.87L6.74907 15.71L7.52907 15.27L8.44907 15.35L9.13907 15.95L9.86906 16.49L10.6791 16.9L11.5891 17.14L12.3091 17.75L12.4191 18.63V19.63L12.5791 20.63L13.1491 21.48L13.8191 22.26L14.7091 22.8L15.7091 23.13L16.7091 23.33L17.7091 22.89L18.6391 22.6L19.5391 22.15L20.2791 21.46L20.6991 20.55L21.2391 19.67L21.1791 18.67L21.0991 17.67L20.9491 16.67L20.0691 16.04L19.5791 15.14L18.6691 14.68L17.7291 14.36L16.5991 14.22ZM15.2891 17.94H15.3691L15.9591 17.52L16.6191 17.37L17.6191 17.73L18.1991 18.73L17.7491 19.82L16.6591 20.18L15.6591 19.7L15.2991 18.7L15.2891 17.94ZM6.13907 11.68L5.70908 12.77L4.61906 13.14L3.61906 12.63L3.24907 11.68L3.59908 10.68L4.59908 10.1L5.68907 10.55L6.13907 11.68ZM15.1391 4.67997L15.5791 3.58997L16.6691 3.21997L17.6091 3.72997L17.9891 4.72997L17.6291 5.72997L16.6291 6.30997L15.5291 5.85997L15.1391 4.67997Z"
            fill="#801F86"
          />
        </svg>
      </button>
    </>
  );
};
